<template>
  <div class="index-box">
    <div class="page-title">当前位置：北京老科技工作者总会会员管理系统 > 个人信息 </div>
    <div class="info-box">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="170px" class="demo-ruleForm">
        <div class="from-box">
          <div v-if="usetState === -1" style="padding: 10px;color: #e90000;">您的申请未通过，原因：{{reason}}</div>
          <div class="info-title">
            <span>基本信息 <i>温馨提示：标注*号项为必填项</i></span>
          </div>
          <div class="info-list">
            <el-form-item label="姓名" prop="name" class="info-item">
              <el-input v-model="ruleForm.name" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="性别" prop="sex" class="info-item">
              <el-radio-group v-model="ruleForm.sex">
                <el-radio label="男"></el-radio>
                <el-radio label="女"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="出生年月" class="info-item" required>
              <el-form-item prop="date">
                <el-date-picker type="month" placeholder="请选择出生年月" v-model="ruleForm.date"
                                style="width: 100%;"></el-date-picker>
              </el-form-item>
            </el-form-item>
            <el-form-item label="政治面貌" prop="face" class="info-item">
              <el-cascader
                placeholder="请选择政治面貌"
                style="width: 100%"
                expand-trigger="hover"
                :options="faceArr"
                v-model="ruleForm.face"
                @change="handleChange">
              </el-cascader>
            </el-form-item>

            <el-form-item label="民族" prop="nation" class="info-item">
              <el-input v-model="ruleForm.nation" placeholder="请输入民族"></el-input>
            </el-form-item>
            <el-form-item label="学历" prop="education" class="info-item">
              <el-select v-model="ruleForm.education" placeholder="请选择学历" style="width: 100%">
                <el-option
                  v-for="item in educationArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="专业" prop="major" class="info-item">
              <el-input v-model="ruleForm.major" placeholder="请输入专业"></el-input>
            </el-form-item>
            <el-form-item label="职称" prop="title" class="info-item">
              <el-input v-model="ruleForm.title" placeholder="请输入职称"></el-input>
            </el-form-item>
            <el-form-item label="身份证号" prop="idNumber" class="info-item">
              <el-input v-model="ruleForm.idNumber" placeholder="请输入身份证号" maxlength="18"></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="tel" class="info-item">
              <el-input v-model="ruleForm.tel" placeholder="请输入联系电话" maxlength="11"></el-input>
            </el-form-item>
            <el-form-item label="所属辖区" prop="address" class="info-item">
              <el-cascader
                style="width: 100%;"
                expand-trigger="hover"
                filterable
                :options="addressArr"
                v-model="ruleForm.address"
                @change="addressChange">
              </el-cascader>
            </el-form-item>
            <el-form-item label="详细地址" prop="detailAddress" class="info-item">
              <el-input v-model="ruleForm.detailAddress" placeholder="请输入详细地址"></el-input>
            </el-form-item>
            <el-form-item label="电子邮箱" prop="email" class="info-item">
              <el-input v-model="ruleForm.email" placeholder="请输入电子邮箱"></el-input>
            </el-form-item>
            <el-form-item label="工作单位" prop="company" class="info-item">
              <el-input v-model="ruleForm.company" placeholder="请输入工作单位"></el-input>
            </el-form-item>
            <el-form-item label="职务" prop="post" class="info-item">
              <el-input v-model="ruleForm.post" placeholder="请输入职务"></el-input>
            </el-form-item>
            <el-form-item label="担任其它社会职务" prop="otherPost" class="info-item">
              <el-input v-model="ruleForm.otherPost" placeholder="请输担任其它社会职务"></el-input>
            </el-form-item>
            <el-form-item label="是否院士" prop="ys" class="info-item" style="width: 40%;">
              <el-radio-group v-model="ruleForm.ys">
                <el-radio label="是"></el-radio>
                <el-radio label="否"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="院士类别" class="info-item" v-show="ruleForm.ys === '是'" style="width: 60%;">
              <el-radio-group v-model="ruleForm.yslb">
                <el-radio label="中国科学院院士"></el-radio>
                <el-radio label="中国工程院院士"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              class="info-item"
              v-for="(domain, index) in ruleForm.domains"
              :label="'获奖情况'"
              :key="domain.key"
              :prop="'domains.' + index + '.value'"
              :rules="{
                         required: false, message: '获奖名称不能为空', trigger: 'blur'
                   }"
            >
              <div style="display: flex;justify-content: flex-start;">
                <el-input v-model="domain.value"></el-input><el-button @click.prevent="removeDomain(domain)">删除</el-button>
              </div>
            </el-form-item>
            <div style="display: flex;justify-content: center;width: 100%;">
              <el-button @click="addDomain">新增获奖名称</el-button>
            </div>
          </div>
        </div>
        <div class="from-box">
          <div class="info-title">
            <span>会员信息</span>
          </div>
          <div class="info-list">
            <el-form-item label-width="250px" label="学习、工作简历及主要成果" class="info-item active">
              <div class="up-box">
                <a href="javascript:void 0" @click="upShow(1)">
                  <b>
                    <i class="iconfont iconshangchuan"></i> 上传文件
                  </b>
                </a>
                <span>支持扩展名：pdf、jpg、png、bmp、doc、docx、excel、rar、zip  </span>
                <el-upload
                  style="display: none;"
                  :action="upImg + '/Index/Morg/UploadImg'"
                  multiple
                  :show-file-list="false"
                  :before-upload="beforeUpload">
                  <i class="btnbtn" ref="upload"></i>
                </el-upload>
              </div>
              <div v-for="(item,index) in ruleForm.file1" :key="index">
                <div class="up-infos">
                  <div>
                    已上传文件：<a :href="item.url" target="_blank">{{item.title}}</a>
                  </div>
                  <i class="iconfont iconlajitong-copy" @click="close(1,index)"></i>
                </div>
              </div>

            </el-form-item>
            <el-form-item label-width="250px" label="身份证扫描件" class="info-item active">
              <div class="up-box">
                <a href="javascript:void 0" @click="upShow(2)">
                  <b>
                    <i class="iconfont iconshangchuan"></i> 上传文件
                  </b>
                </a>
                <span>支持扩展名：pdf、jpg、png、bmp、doc、docx、excel、rar、zip  </span>

              </div>
              <div v-for="(item,index) in ruleForm.file2" :key="index">
                <div class="up-infos">
                  <div>
                    已上传文件：<a :href="item.url" target="_blank">{{item.title}}</a>
                  </div>
                  <i class="iconfont iconlajitong-copy" @click="close(2,index)"></i>
                </div>

              </div>
            </el-form-item>
            <el-form-item label-width="250px" label="学历证书扫描件" class="info-item active">
              <div class="up-box">
                <a href="javascript:void 0" @click="upShow(3)">
                  <b>
                    <i class="iconfont iconshangchuan"></i> 上传文件
                  </b>
                </a>
                <span>支持扩展名：pdf、jpg、png、bmp、doc、docx、excel、rar、zip  </span>

              </div>
              <div v-for="(item,index) in ruleForm.file3" :key="index">
                <div class="up-infos">
                  <div>
                    已上传文件：<a :href="item.url" target="_blank">{{item.title}}</a>
                  </div>
                  <i class="iconfont iconlajitong-copy" @click="close(3,index)"></i>
                </div>
              </div>
            </el-form-item>
            <el-form-item label-width="250px" label="职称证书扫描件" class="info-item active">
              <div class="up-box">
                <a href="javascript:void 0" @click="upShow(4)">
                  <b>
                    <i class="iconfont iconshangchuan"></i> 上传文件
                  </b>
                </a>
                <span>支持扩展名：pdf、jpg、png、bmp、doc、docx、excel、rar、zip    </span>

              </div>
              <div v-for="(item,index) in ruleForm.file4" :key="index">
                <div class="up-infos">
                  <div>
                    已上传文件：<a :href="item.url" target="_blank">{{item.title}}</a>
                  </div>
                  <i class="iconfont iconlajitong-copy" @click="close(4,index)"></i>
                </div>
              </div>
            </el-form-item>
            <el-form-item label-width="250px" label="其他奖项等证明专业水平或成果的材料" class="info-item active">
              <div class="up-box">
                <a href="javascript:void 0" @click="upShow(5)">
                  <b>
                    <i class="iconfont iconshangchuan"></i> 上传文件
                  </b>
                </a>
                <span>支持扩展名：pdf、jpg、png、bmp、doc、docx、excel、rar、zip  </span>

              </div>
              <div v-for="(item,index) in ruleForm.file5" :key="index">
                <div class="up-infos">
                  <div>
                    已上传文件：<a :href="item.url" target="_blank">{{item.title}}</a>
                  </div>
                  <i class="iconfont iconlajitong-copy" @click="close(5,index)"></i>
                </div>
              </div>
            </el-form-item>

          </div>
          <el-button class="submit-btn" @click="submitForm('ruleForm')" :class="{active:usetState === 0}">提交修改</el-button>
          <el-button class="submit-btn" v-if="usetState === 0">审核中</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
  import config from '../../config/index'
  import {
    regionData,
    CodeToText,
  } from 'element-china-area-data'

  export default {
    name: "Info",
    data() {
      // var validatorTel = (rule, value, callback) => {
      //   if (!(/^1[3456789]\d{9}$/.test(value))) {
      //     return callback(new Error('请输入正确的手机号'));
      //   } else {
      //     callback();
      //   }
      // };
      var validatorIdNumber = (rule, value, callback) => {
        if (!(/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value))) {
          return callback(new Error('请输入正确的身份证号'));
        } else {
          callback();
        }
      };
      return {
        upImg:config.urlStr,
        upIndex:'',
        usetState:'',
        reason:'',
        ruleForm: {
          name: '',          //  姓名
          sex: '',           //  性别
          date: '',          //  出生日前
          face: '',          //  政治面貌
          nation: '',        //  民族
          education: '',     //  学历
          major: '',         //  专业
          title: '',         //  职称
          idNumber: '',      //身份证号
          tel: '',           //联系电话
          address: '',       //地址
          detailAddress: '', //详细地址
          email: '',         //邮箱
          company: '',       //单位
          post: '',          //职务
          otherPost: '',     //其它职务
          ys: '',          //  是否院士
          yslb:'',        // 院士类别
          domains: [{      //   获奖情况
            value: ''
          }],
          file1:[],
          file2:[],
          file3:[],
          file4:[],
          file5:[],
          checked: true,      // 同意入会协议
        },
        rules: {
          name: [
            {required: true, message: '请输入姓名', trigger: 'blur'},
          ],
          sex: [
            {required: true, message: '请选择性别', trigger: 'change'}
          ],
          ys: [
            {required: true, message: '请选择是否院士', trigger: 'change'}
          ],
          yslb: [
            {required: true, message: '请选择院士类别', trigger: 'change'}
          ],
          date: [
            {type: 'date', required: true, message: '出生年月', trigger: 'change'}
          ],
          face: [
            {required: true, message: '请选择政治面貌', trigger: 'change'}
          ],
          nation: [
            {required: true, message: '请输入民族', trigger: 'blur'},
          ],
          education: [
            {required: true, message: '请选择学历', trigger: 'change'},
          ],
          major: [
            {required: true, message: '请输入专业', trigger: 'blur'},
          ],
          title: [
            {required: true, message: '请输入职称', trigger: 'blur'},
          ],
          idNumber: [
            {required: true, message: '请输入身份证号', trigger: 'blur'},
            {validator: validatorIdNumber, trigger: 'blur'},
          ],
          tel: [
            {required: true, message: '请输入联系电话', trigger: 'blur'},
            // {validator: validatorTel, trigger: 'blur'},
          ],
          address: [
            {required: true, message: '请输入所属辖区', trigger: 'change'},
          ],
          detailAddress: [
            {required: true, message: '请输入详细地址', trigger: 'blur'},
          ],
          email: [
            {required: true, message: '请输入邮箱地址', trigger: 'blur'},
            {type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur'}
          ],
          company: [
            {required: true, message: '请输入工作单位', trigger: 'blur'},
          ],
          post: [
            {required: true, message: '请输入职务', trigger: 'blur'},
          ],
          otherPost: [
            {required: true, message: '请输入担任其它社会职务', trigger: 'blur'},
          ],
        },
        faceArr: [], //  政治面貌
        educationArr: [], //  学历
        addressArr: regionData
      }
    },
    created() {
      this.init()
      this.getFrom()
      this.usetState = Number(this.$store.state.user.checkStatus)
      this.$emit('setNav', 3)
    },
    methods: {

      // 获奖名称  删除
      removeDomain(item) {
        var index = this.ruleForm.domains.indexOf(item)
        if (index !== -1) {
          this.ruleForm.domains.splice(index, 1)
        }
      },
      //  获奖名称添加
      addDomain() {
        this.ruleForm.domains.push({
          value: '',
          key: Date.now()
        });
      },

      close(num, index) {
        this.$confirm('此操作将永久删除该文件, 是否继续?', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          switch (num) {
            case 1:
              this.ruleForm.file1.splice(index, 1)
              break
            case 2:
              this.ruleForm.file2.splice(index, 1)
              break
            case 3:
              this.ruleForm.file3.splice(index, 1)
              break
            case 4:
              this.ruleForm.file4.splice(index, 1)
              break
            case 5:
              this.ruleForm.file5.splice(index, 1)
              break
          }
        }).catch(() => {

        });
      },
      /*
      * 获取用户信息
      * */
      getFrom() {
        this.$api.apiContent.getUser({
          token: this.$store.state.user.token
        }).then(res => {
          console.log(res)
          var ary = res.row.prize.split(',')
          var Ary = []
          ary.map(item => {
            Ary.push({
              value: item
            })
          })
          this.reason = res.row.reason
          this.ruleForm = {
            name: res.row.nickname,          //  姓名
            sex: res.row.sex == 1?'男':'女',           //  性别
            ys: res.row.naFlag == 1 ? '是' : '否',           //  是否院士
            yslb: res.row.naName == '' ? (res.row.naName == '0' ? '中国科学院院士' : '中国工程院院士') : '',           //  是否院士
            domains: Ary,                              //  获得的大奖
            date: new Date(res.row.birthdayText),          //  出生日前
            face: res.row.politic.split(','),          //  政治面貌
            nation: res.row.nation,        //  民族
            education: Number(res.row.education),     //  学历
            major: res.row.major,         //  专业
            title: res.row.title,         //  职称
            idNumber: res.row.idcard,      //身份证号
            tel: res.row.phone,           //联系电话
            address: res.row.addrCode.split(','),       //地址
            detailAddress: res.row.addrDetail, //详细地址
            email: res.row.email,         //邮箱
            company: res.row.workUnit,       //单位
            post: res.row.duty,          //职务
            otherPost: res.row.dutyOther,     //其它职务
            file1: JSON.parse(res.row.studyFile),
            file2: JSON.parse(res.row.idcardFile),
            file3: JSON.parse(res.row.eduFile),
            file4: JSON.parse(res.row.titleFile),
            file5: JSON.parse(res.row.otherFile),
            t1name: res.row.ref1,
            t2name: res.row.ref2,
            t3name: res.row.refUnit,
            checked: true,      // 同意入会协议
          }
          if(this.ruleForm.face.length === 1){
            this.ruleForm.face = [Number(this.ruleForm.face[0])]
          }else{
            this.ruleForm.face = [Number(this.ruleForm.face[0]),Number(this.ruleForm.face[1])]
          }
          this.$store.state.user.checkStatus = res.row.checkStatus
          this.usetState = Number(this.$store.state.user.checkStatus)
          console.log(this.ruleForm.yslb)
        }).catch(e => {
          console.log(e)
        })
      },
      /*
      * 提交用户信息
      * */
      submitForm(formName) {
        console.log(this.$tools.ZHDate(new Date(this.ruleForm.date)))
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(this.ruleForm.ys == '是'){
              if(this.ruleForm.yslb == ''){
                this.$toast('请选择院士类别')
                return false
              }
            } else {
              this.ruleForm.yslb = ''
            }
            var domainsAry = []
            this.ruleForm.domains.map(item => {
              domainsAry.push(item.value)
            })
            this.$api.apiContent.submitUser({
              token: this.$store.state.user.token,
              nickname: this.ruleForm.name,
              sex: this.ruleForm.sex == '男' ? 1 : 0,
              naFlag: this.ruleForm.ys == '是' ? 1 : 0 ,
              naName:this.ruleForm.yslb == '' ? '' : (this.ruleForm.yslb == '中国工程院院士' ? 1 : 0),
              prize: domainsAry.join(','),
              birthdayText: this.$tools.ZHDate(new Date(this.ruleForm.date)),
              politic: this.ruleForm.face.join(','),
              nation: this.ruleForm.nation,
              education: this.ruleForm.education,
              major: this.ruleForm.major,
              title: this.ruleForm.title,
              idcard: this.ruleForm.idNumber,
              phone: this.ruleForm.tel,
              addrCode: this.ruleForm.address.join(','),
              addrText: [CodeToText[this.ruleForm.address[0]], CodeToText[this.ruleForm.address[1]], CodeToText[this.ruleForm.address[2]]].join(','),
              addrDetail: this.ruleForm.detailAddress,
              email: this.ruleForm.email,
              workUnit: this.ruleForm.company,
              duty: this.ruleForm.post,
              dutyOther: this.ruleForm.otherPost,
              studyFile: JSON.stringify(this.ruleForm.file1),
              idcardFile: JSON.stringify(this.ruleForm.file2),
              eduFile: JSON.stringify(this.ruleForm.file3),
              titleFile: JSON.stringify(this.ruleForm.file4),
              otherFile: JSON.stringify(this.ruleForm.file5),
              ref1: '',
              ref2: '',
              refUnit: '',
            }).then(() => {
              this.$toast('提交成功')
              // this.$store.state.user.checkStatus = 0
              // this.usetState = Number(this.$store.state.user.checkStatus)
              this.getFrom()
            }).catch(e => {
              this.$toast(e.msg)
            })

          } else {
            this.$toast('信息填写有误，请确认')
            return
          }
        });
      },

      //  显示上传文件
      upShow(num) {
        this.upIndex = num
        document.querySelector('.btnbtn').click()
      },
      //  上传文件
      beforeUpload(file) {
        const loading = this.$loading({
          lock: true,
          text: '上传中，请稍后',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        let fd = new window.FormData();
        fd.append('files', file)
        fd.append('token', this.$store.state.user.token)
        this.$api.apiContent.file(fd).then(res => {
          loading.close();
          switch (this.upIndex) {
            case 1:
              // this.ruleForm.file1 = res.row.urlList[0]
              this.ruleForm.file1.push({
                title: file.name,
                url: res.row.urlList[0]
              })
              break
            case 2:
              // this.ruleForm.file2 = res.row.urlList[0]
              this.ruleForm.file2.push({
                title: file.name,
                url: res.row.urlList[0]
              })
              break
            case 3:
              // this.ruleForm.file3 = res.row.urlList[0]
              this.ruleForm.file3.push({
                title: file.name,
                url: res.row.urlList[0]
              })
              break
            case 4:
              // this.ruleForm.file4 = res.row.urlList[0]
              this.ruleForm.file4.push({
                title: file.name,
                url: res.row.urlList[0]
              })
              break
            case 5:
              // this.ruleForm.file5 = res.row.urlList[0]
              this.ruleForm.file5.push({
                title: file.name,
                url: res.row.urlList[0]
              })
              break
          }
          this.upIndex = ''
        }).catch(e => {
          this.$message.error(e.info)
        })
        return false
      },
      //  地区选择
      addressChange(arr) {
        this.ruleForm.address = arr
      },
      /*
      * 政治面貌选择
      * */
      handleChange(value) {
        console.log(value);
      },
      init() {
        this.$api.apiContent.getMianmao({
          token: this.$store.state.user.token
        }).then(res => {
          res.row.map(item => {
            this.faceArr.push({
              value: item.id,
              label: item.text,
              children: item.child.length > 0 ? item.child : ''
            })
          })
          this.faceArr.map(item => {
            if (item.children) {
              item.children.map(items => {
                items.value = items.id
                items.label = items.text
              })
            }
          })
        }).catch(e => {
          console.log(e)
        })
        this.$api.apiContent.getEdu({
          token: this.$store.state.user.token
        }).then(res => {
          console.log(res)
          res.row.map(item => {
            this.educationArr.push({
              value: item.id,
              label: item.text,
            })
          })
        }).catch(e => {
          console.log(e)
        })
      }
    },
  }
</script>

<style scoped lang="scss">
  .index-box {
    .page-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 62px;
      padding: 0 24px;
      line-height: 62px;
      background-color: #ffffff;
      margin-bottom: 10px;

      a {
        display: block;
        width: 102px;
        height: 26px;
        text-align: center;
        line-height: 26px;
        color: #2b8ee3;
        background-color: #e9f5ff;
        border-radius: 13px;
      }
    }

    .info-box {
      min-height: 712px;
      padding: 25px 27px;
      background: #fff;

      .info-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: 50px;
        line-height: 50px;
        padding: 0 12px;
        background-image: linear-gradient(0deg,
          #2084da 0%,
          #3295e8 100%);
        border-radius: 4px;

        span {
          font-size: 20px;
          font-weight: bold;
          color: #ffffff;

          i {
            font-size: 12px;
            font-weight: normal;
          }
        }

        a.more {
          width: 56px;
          height: 26px;
          text-align: center;
          line-height: 26px;
          font-size: 14px;
          color: #0c7cbc;
          background-color: #e9f5ff;
          border-radius: 13px;
        }
      }

      .info-list {
        padding: 30px 0;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        flex-wrap: wrap;

        .info-item {
          width: 50%;
          &.active {
            width: 100%;
          }
          .up-box{
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            a{
              display: flex;
              align-items: center;
              justify-content: space-around;
              width: 110px;
              height: 36px;
              text-align: center;
              line-height: 36px;
              color: #fff;
              font-size: 16px;
              margin-right: 20px;
              background-image: linear-gradient(0deg,
                #2084da 0%,
                #3295e8 100%);
              border-radius: 4px;
              border: solid 1px #036cc4;
              b{
                display: flex;
                align-items: center;
                i{
                  font-size: 24px;
                }
              }

            }
            span{
              color: #999;
            }
          }
          .up-infos {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            height: 36px;
            padding: 0 12px;
            line-height: 36px;
            background-color: #e9f5ff;
            border-radius: 4px;
            margin-bottom: 5px;

            div {
              a {
                color: #2b8ee3;
              }
            }

            i {
              font-size: 20px;
              color: #2b8ee3;
              cursor: pointer;
            }
          }
        }

        .shengming {
          width: 100%;
          padding: 20px 30px;
          background-color: #e9f5ff;
          border-radius: 4px;

          p {
            line-height: 150%;
            text-indent: 28px;
          }
        }

      }

      .submit-btn {
        display: block;
        width: 162px;
        height: 48px;
        padding: 0;
        border: 0;
        margin: 40px auto;
        font-size: 18px;
        color: #fff;
        background-image: linear-gradient(90deg,
          #0d80c1 0%,
          #1aa8e3 100%);
        border-radius: 8px;
        &.active{
          display: none;
        }
      }
    }
  }
</style>
